import React, { PureComponent } from "react";
import { compose } from "redux";
import SvgIcon from "@material-ui/core/SvgIcon";

class MinusSquare extends PureComponent {
  render() {
    return (
      <SvgIcon fontSize="inherit" {...this.props}>
        <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
      </SvgIcon>
    );
  }
}
export default compose()(MinusSquare);
